import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { userSelectors } from 'reducers';
import { parseFullName, parseNumber, parseSum } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import { Typography } from '@mui/material';

const SubscriptionInfo = ({ subscription }) => {
    const { firstName, lastName } = useSelector(userSelectors.getInternalUser);

    const shareValue = useMemo(
        () => subscription?.investmentCharacteristics?.shareValue || 0,
        [subscription]
    );
    const investingSum = useMemo(
        () => subscription?.investmentCharacteristics?.investingSum || 0,
        [subscription]
    );

    return subscription?.investmentFund?.evergreen ? (
        <React.Fragment>
            <Typography mb={4}>
                <b>{parseFullName({ firstName, lastName })}</b> {texts.YOU_HAVE_INVESTED}{' '}
                <b>{parseSum(investingSum)}</b> {texts.INTO_THE_FUND}{' '}
                <b>{subscription.investmentFund.name}</b> {texts.COMMERCIALISED_BY}{' '}
                <b>{subscription.investmentFund.sgp?.name}</b>. {texts.SGP_WILL_PROCEED}
            </Typography>
            <Typography>
                {texts.SGP_WILL_SEND_EMAIL}
                <b>{subscription.investmentFund.name}</b>, {texts.SGP_SIGNATURE_FOLLOWING_PAYMENT}
            </Typography>
        </React.Fragment>
    ) : (
        <React.Fragment>
            <Typography gutterBottom>
                {texts.YOU_HAVE_INVESTED[0].toUpperCase() + texts.YOU_HAVE_INVESTED.slice(1)}{' '}
                <b>{parseSum(investingSum)}</b> {texts.REPRESENTING}{' '}
                <b>{parseNumber(investingSum / shareValue)}</b> {texts.FUND_SHARES}{' '}
                <b>{subscription.investmentFund.name}</b>.
            </Typography>
            <Typography gutterBottom>{texts.SIGNED_BY_SGP}</Typography>
        </React.Fragment>
    );
};

SubscriptionInfo.propTypes = { subscription: PropTypes.object };

export default SubscriptionInfo;
